import { CategoriesTypes } from '../ActionTypes/CategoriesTypes';

let initialSate = {
    CategoryList: [],
    CleanerCategoryList: [],
    CleanerCategoryPagination: null,
};

const CategoriesReducer = (state = initialSate, action) => {
    switch (action.type) {

        case CategoriesTypes.GET_CATEGORIES:
            state = { ...state, CategoryList: action.payload };
            break;

        case CategoriesTypes.GET_CLEANER_CATEGORIES:
            let CleanerCategoryList_Copy = [];
            CleanerCategoryList_Copy = [
                ...state.CleanerCategoryList,
                ...action.payload.data,
            ];
            state = {
                ...state,
                CleanerCategoryPagination: action.payload,
                CleanerCategoryList: CleanerCategoryList_Copy
            };
            break;

        case CategoriesTypes.CLEAR_CLEANER_CATEGORIES:
            state = {
                ...state,
                CleanerCategoryPagination: null,
                CleanerCategoryList: []
            };
            break;
    }
    return state;
};

export default CategoriesReducer;
